import { msalInstance, loginRequest } from "../authConfig";

export async function loginUser() {
  const accounts = msalInstance.getAllAccounts();

  if (accounts.length > 0) {
    try {
      const silentResult = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      });
      console.log("Silent login successful:", silentResult);
      localStorage.setItem("userInfo", JSON.stringify(silentResult.account));
      localStorage.setItem("loginType", "microsoft");
      return silentResult.account;
    } catch (error) {
      console.warn("Silent login failed, falling back to popup:", error);
    }
  }

  try {
    const popupResult = await msalInstance.loginPopup(loginRequest);
    console.log("Popup login successful:", popupResult);
    localStorage.setItem("userInfo", JSON.stringify(popupResult.account));
    localStorage.setItem("loginType", "microsoft");
    return popupResult.account;
  } catch (popupError) {
    console.error("Popup login failed:", popupError);
    throw popupError;
  }
}


// Check if user is logged in
export async function isLoggedIn() {
  const userInfo = localStorage.getItem("userInfo");
  return !!userInfo;
}

// Logout function
export async function logout() {
  const loginType = localStorage.getItem("loginType");
console.log("Logging out user with loginType:", loginType);
  try {
    if (loginType === "microsoft") {
      await msalInstance.logoutPopup({
        postLogoutRedirectUri: window.location.origin
      });
      localStorage.clear();
      window.location.href = "/admin"; // or navigate("/login")

    }
    else {
      localStorage.clear();
      window.location.href = "/login"; // or navigate("/login")
    }
  } catch (error) {
    console.error("Logout failed:", error);
  }
}
